import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.find.js";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (g && (g = 0, op[0] && (_ = 0)), _) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

import { Sentry } from '@woulsl/sentry-config';
import storage from '@woulsl/storage';
import dayjs from 'dayjs';
import QS from 'qs';
import { showSameActivityOrderModal } from '@/components/SameActivityOrderModal';
import { APP_ROUTE_INDEX_MAP, EXTENDS_DATA, LOCAL_BASE_URL } from '@/const';
import { enums, isJoJoUpMaskIos } from '@/const/enums';
import { _trans } from '@/lib/i18next';
import Toast from '@/plugins/Toast';
import { unbindAccount } from '@/services/landing';
import { fetchExtendSubject } from '@/services/landingX';
import { isJoJoBeansBrowser, isJoJoBrowser, isJoJoReadBrowser, isJoJoUpBrowser, isJoJoUpRemakeBrowser, isWXBrowser, isWXMiniAppBrowser, localUrlJump, moneyTransform, qsParse, urlJump } from '@/utils';
import { jumpAppRoute } from '@/utils/bridge';
import { sensClickInitiative, sensElementView } from '@/utils/sensors';
import { subjectTexts } from '../../../utils/index';
import { toCreateOrder } from './litePlaceOrder';
import { openPageByMiniprogram } from './methods';
import { buildDownloadPageUrl, getCachedDownloadSceneType, prefetchDownloadSceneType, resolveDownloadPageUrl } from './methods/downloadSceneType';
import { newPromptFunc, promptFunc, toOrderModal } from './methods/help';
var isWx = isWXBrowser();
var isJoJoApp = isJoJoBrowser();
var isInMiniProgram = isWXMiniAppBrowser(); // jojoread APP 专属判断（tinman-router:// 协议为 jojoread 独有），isJoJoBrowser 为叫叫系泛判断

var isJoJoReadApp = isJoJoReadBrowser();
var JoJoUpBrowser = isJoJoUpBrowser();
var isSupportBrowser = isJoJoReadBrowser() || JoJoUpBrowser || isJoJoBeansBrowser() || isJoJoUpRemakeBrowser();

var getRender407Btn = function getRender407Btn() {
  if (isSupportBrowser) {
    return {
      title: '您已有同类内容',
      btnText: '去学习',
      btnText2: '知道了',
      content: '您账号中已有同类内容，可直接学习',
      onOk: function onOk() {
        window.location.href = enums.schema.study;
      }
    };
  } else if (isInMiniProgram) {
    return {
      title: '您已有同类内容',
      btnText: '知道了',
      content: "\u60A8\u8D26\u53F7\u4E2D\u5DF2\u6709\u540C\u7C7B\u5185\u5BB9\uFF0C\u8BF7\u6253\u5F00".concat(enums.title, " APP\u5B66\u4E60")
    };
  } else if (isWx) {
    return {
      title: '您已有同类内容',
      btnText: "\u6253\u5F00".concat(enums.title),
      btnText2: '知道了',
      content: "\u60A8\u8D26\u53F7\u4E2D\u5DF2\u6709\u540C\u7C7B\u5185\u5BB9\uFF0C\u8BF7\u6253\u5F00".concat(enums.title, " App\u5B66\u4E60"),
      onOk: function onOk() {
        window.location.href = enums.schema.downloadUrl;
      }
    };
  } else {
    return {
      title: '您已有同类内容',
      content: "\u60A8\u8D26\u53F7\u4E2D\u5DF2\u6709\u540C\u7C7B\u5185\u5BB9\uFF0C\u8BF7\u6253\u5F00".concat(enums.title, " APP\u5B66\u4E60"),
      btnText: '知道了'
    };
  }
};

var getSubjectString = function getSubjectString(conflictSubjectCodes) {
  if (Array.isArray(conflictSubjectCodes) && conflictSubjectCodes.length > 0) {
    return "\u300C".concat(conflictSubjectCodes.map(function (item) {
      return subjectTexts[item];
    }).join('，'), "\u300D");
  }

  return '';
};

var getRender1Btn = function getRender1Btn(_a) {
  var subjectString = _a.subjectString,
      _b = _a.isActive,
      isActive = _b === void 0 ? false : _b;
  var addafterString = isActive ? '请激活内容后开始学习。' : '';

  if (isSupportBrowser) {
    return {
      title: '您已有同类内容',
      btnText: '去学习',
      btnText2: '知道了',
      content: "\u60A8\u8D26\u53F7\u4E2D\u5DF2\u6709\u540C\u7C7B".concat(subjectString, "\u5185\u5BB9\uFF0C").concat(addafterString || '请先完成学习吧'),
      onOk: function onOk() {
        window.location.href = enums.schema.study;
      }
    };
  } else if (isInMiniProgram) {
    return {
      title: '您已有同类内容',
      btnText: '知道了',
      content: "\u60A8\u8D26\u53F7\u4E2D\u5DF2\u6709\u540C\u7C7B".concat(subjectString, "\u5185\u5BB9\uFF0C").concat(addafterString || "\u8BF7\u6253\u5F00".concat(enums.title, " APP\u5B66\u4E60"))
    };
  } else if (isWx) {
    return {
      title: '您已有同类内容',
      btnText: "\u6253\u5F00".concat(enums.title),
      btnText2: '知道了',
      content: "\u60A8\u8D26\u53F7\u4E2D\u5DF2\u6709\u540C\u7C7B".concat(subjectString, "\u5185\u5BB9\uFF0C").concat(addafterString || "\u8BF7\u6253\u5F00".concat(enums.title, " APP\u5B66\u4E60")),
      onOk: function onOk() {
        window.location.href = enums.schema.downloadUrl;
      }
    };
  } else {
    return {
      title: '您已有同类内容',
      content: "\u60A8\u8D26\u53F7\u4E2D\u5DF2\u6709\u540C\u7C7B".concat(subjectString, "\u5185\u5BB9\uFF0C").concat(addafterString || "\u8BF7\u6253\u5F00".concat(enums.title, " APP\u5B66\u4E60").concat(isJoJoUpMaskIos ? '' : " \uFF0C\u53EF\u5728\u5E94\u7528\u5E02\u573A\u4E0B\u8F7D\u300C".concat(enums.title, "\u300D"))),
      btnText: '知道了'
    };
  }
};

var query = qsParse();
/**
 * 从 RootDataType 对象中提取特定的键值对，并将它们格式化为查询字符串，以便添加到 URL 中。
 * 这些键值对通常用于跟踪营销活动的来源和参数。
 *
 * @param data - 包含营销活动相关信息的对象。
 * @returns 格式化后的查询字符串，用于跟踪营销活动。
 */

export function getCampaignStr(data) {
  var _a = data || {},
      campaignId = _a.campaignId,
      campaignPageId = _a.campaignPageId,
      channel = _a.channel,
      linkId = _a.linkId,
      channelNo = _a.channelNo;

  var commonParams = QS.stringify({
    campId: campaignId || undefined,
    cpId: campaignPageId || undefined,
    channel: channel || undefined,
    channelNo: channelNo || undefined,
    sc: query === null || query === void 0 ? void 0 : query.sc,
    linkId: linkId || undefined,
    afterJumpKey: query === null || query === void 0 ? void 0 : query.afterJumpKey,
    // SP103 新增定级评估来源标识参数透传
    fr: query === null || query === void 0 ? void 0 : query.fr,
    // SP120 新增定级指定返回APP页面标识
    appUrlKey: query === null || query === void 0 ? void 0 : query.appUrlKey,
    // SP134 新增入校测评指定参数标识
    publicAssessId: query === null || query === void 0 ? void 0 : query.publicAssessId,
    publicAssessTaskNo: query === null || query === void 0 ? void 0 : query.publicAssessTaskNo
  });
  return commonParams ? "&".concat(commonParams) : '';
}
export var handleFlag40 = function handleFlag40(frontErrorResp, replace) {
  if (!frontErrorResp) {
    if (!(__store === null || __store === void 0 ? void 0 : __store.isAccountOutModal)) {
      Toast.fail(_trans('courseSelection.toast.systemErr'), 1);
    }

    return;
  }

  var flagCode = frontErrorResp.flagCode,
      frontUserResp = frontErrorResp.frontUserResp,
      frontAppletResp = frontErrorResp.frontAppletResp,
      frontCourseNotActivate = frontErrorResp.frontCourseNotActivate;
  var paramStr = '';

  if (flagCode === 7) {
    if (!frontUserResp) {
      Toast.fail(_trans('courseSelection.toast.systemErr'), 1);
      return;
    }

    var avatarUrl = frontUserResp.avatarUrl,
        nickname = frontUserResp.nickname;
    paramStr = "&url=".concat(encodeURIComponent(avatarUrl), "&name=").concat(nickname);
  }

  if (flagCode === 8) {
    if (!frontAppletResp) {
      Toast.fail(_trans('courseSelection.toast.systemErr'), 1);
      return;
    }

    var url = frontAppletResp.url,
        name_1 = frontAppletResp.name;
    paramStr = "&url=".concat(encodeURIComponent(url), "&name=").concat(name_1);
  }

  if (flagCode === 407) {
    if (!frontAppletResp) {
      Toast.fail('您近期已体验过相似内容', 1);
      return;
    }
  }

  if ([408003, 408004, 408005, 408006].includes(flagCode)) {
    var _a = frontCourseNotActivate || {},
        _b = _a.teacherWechatQr,
        teacherWechatQr = _b === void 0 ? '' : _b,
        _c = _a.nickname,
        nickname = _c === void 0 ? '' : _c,
        _d = _a.id,
        id = _d === void 0 ? '' : _d,
        _e = _a.wechatId,
        wechatId = _e === void 0 ? '' : _e,
        _f = _a.wechatAccountId,
        wechatAccountId = _f === void 0 ? '' : _f,
        _g = _a.profileUrl,
        profileUrl = _g === void 0 ? '' : _g;

    var queryParams = ["code=".concat(flagCode), "teacherWechatQr=".concat(encodeURIComponent(teacherWechatQr)), "name=".concat(nickname), "id=".concat(id), "wechatId=".concat(wechatId), "wechatAccountId=".concat(wechatAccountId), "url=".concat(encodeURIComponent(profileUrl))];
    urlJump("/error?".concat(queryParams.join('&')), !!replace);
    return;
  }

  urlJump("/error?code=".concat(flagCode).concat(paramStr), !!replace);
};
export var handleFlagCode1 = function handleFlagCode1(data, rootData, _a) {
  var subjectString = _a.subjectString;

  var _b = getRender1Btn({
    subjectString: subjectString
  }),
      title = _b.title,
      content = _b.content,
      btnText = _b.btnText,
      btnText2 = _b.btnText2,
      onOk = _b.onOk;

  newPromptFunc({
    title: title,
    content: content,
    btnText: btnText,
    btnText2: btnText2,
    hideCloseIcon: true,
    onOk: onOk
  });
  sensElementView({
    c_element_name: '下单异常弹窗曝光',
    url_id: rootData === null || rootData === void 0 ? void 0 : rootData.linkId,
    activity_id: rootData === null || rootData === void 0 ? void 0 : rootData.campaignId,
    material_ids: ["".concat(rootData === null || rootData === void 0 ? void 0 : rootData.campaignPageId)],
    activity_label: '投放',
    material_type: '异常原因：有在学/有待学/有7天内结营同科目',
    fail_reason: "".concat((data === null || data === void 0 ? void 0 : data.flagCode) || '')
  });
}; // SP118 新增转介绍场景 课程冲突时 弹窗逻辑调整

var beforeRenderPrompt = function beforeRenderPrompt(_a) {
  var rootData = _a.rootData,
      subjectString = _a.subjectString,
      failCallback = _a.failCallback;
  return __awaiter(void 0, void 0, void 0, function () {
    var frontCampaignSkuResps, _b, active_1, campaignId, _c, resultCode, extendData, _d, recommend, joinInfo, extendSubjectSkus, _e, firstSubjectSku_1, btnText, error_1;

    var _f;

    return __generator(this, function (_g) {
      switch (_g.label) {
        case 0:
          _g.trys.push([0, 2, 3, 4]);

          Toast.load('请稍后', 400000);
          frontCampaignSkuResps = rootData.frontCampaignSkuResps, _b = rootData.active, active_1 = _b === void 0 ? 0 : _b, campaignId = rootData.campaignId;
          return [4
          /*yield*/
          , fetchExtendSubject({
            scene: 'REFERRAL_LINK_LIMIT_EXTEND_SUBJECT',
            linkId: query === null || query === void 0 ? void 0 : query.linkId,
            skuId: (_f = frontCampaignSkuResps === null || frontCampaignSkuResps === void 0 ? void 0 : frontCampaignSkuResps[active_1]) === null || _f === void 0 ? void 0 : _f.skuId,
            channelNo: query === null || query === void 0 ? void 0 : query.channelNo,
            campaignId: campaignId
          })];

        case 1:
          _c = _g.sent(), resultCode = _c.resultCode, extendData = _c.data;

          if (resultCode !== 200 || !extendData) {
            failCallback === null || failCallback === void 0 ? void 0 : failCallback();
            return [2
            /*return*/
            ];
          }

          _d = extendData || {}, recommend = _d.recommend, joinInfo = _d.joinInfo;
          extendSubjectSkus = (recommend || {}).extendSubjectSkus;

          if (!(joinInfo === null || joinInfo === void 0 ? void 0 : joinInfo.canJoin) || !Array.isArray(extendSubjectSkus) || !(extendSubjectSkus === null || extendSubjectSkus === void 0 ? void 0 : extendSubjectSkus.length)) {
            failCallback === null || failCallback === void 0 ? void 0 : failCallback();
            return [2
            /*return*/
            ];
          }

          _e = extendSubjectSkus[0], firstSubjectSku_1 = _e === void 0 ? {} : _e;
          sensElementView({
            c_element_name: '推荐其他课程弹窗',
            url_id: (rootData === null || rootData === void 0 ? void 0 : rootData.linkId) || '',
            sku_id: "".concat((firstSubjectSku_1 === null || firstSubjectSku_1 === void 0 ? void 0 : firstSubjectSku_1.skuId) || ''),
            activity_id: (rootData === null || rootData === void 0 ? void 0 : rootData.campaignId) || '',
            material_ids: ["".concat((rootData === null || rootData === void 0 ? void 0 : rootData.campaignPageId) || '')],
            activity_label: '投放',
            custom_state: (query === null || query === void 0 ? void 0 : query.inviteCode) || ''
          });
          btnText = (firstSubjectSku_1 === null || firstSubjectSku_1 === void 0 ? void 0 : firstSubjectSku_1.price) > 0 ? "".concat(moneyTransform(firstSubjectSku_1.price), "\u5143\u7ACB\u5373\u9886\u53D6") : '立即领取';
          newPromptFunc({
            /* html */
            content: "<div class=\"before-con\">\n      <div class=\"before-con-desc\">\n        <span>\u60A8\u5DF2\u6709\u540C\u7C7B".concat(subjectString, "\u5185\u5BB9</span>\n        <span>\u4E3A\u60A8\u63A8\u8350\u66F4\u591A\u7CBE\u9009\u5185\u5BB9</span>\n      </div>\n      <div class=\"before-con-product\">\n        <img class=\"before-con-product-img\" src=\"").concat(firstSubjectSku_1 === null || firstSubjectSku_1 === void 0 ? void 0 : firstSubjectSku_1.skuImage, "\"/>\n      </div>\n    </div>"),
            showClose: true,
            hideCloseIcon: true,
            btnText: btnText,
            onClose: function onClose() {
              console.log('关闭');
            },
            onCenterBtnClick: function onCenterBtnClick(dom) {
              return __awaiter(this, void 0, void 0, function () {
                var result;
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      sensClickInitiative({
                        $element_name: '推荐其他课程弹窗_领取',
                        $element_id: "".concat((firstSubjectSku_1 === null || firstSubjectSku_1 === void 0 ? void 0 : firstSubjectSku_1.skuId) || ''),
                        url_id: (rootData === null || rootData === void 0 ? void 0 : rootData.linkId) || '',
                        sku_id: "".concat((firstSubjectSku_1 === null || firstSubjectSku_1 === void 0 ? void 0 : firstSubjectSku_1.skuId) || ''),
                        activity_id: (rootData === null || rootData === void 0 ? void 0 : rootData.campaignId) || '',
                        material_ids: ["".concat((rootData === null || rootData === void 0 ? void 0 : rootData.campaignPageId) || '')],
                        activity_label: '投放',
                        custom_state: (query === null || query === void 0 ? void 0 : query.inviteCode) || ''
                      }); // SP122存储扩科sku数据，用于后面重新支付 跳转对应确认订单页

                      storage.set(EXTENDS_DATA, __assign(__assign({}, firstSubjectSku_1 || {}), {
                        rootCampaignId: rootData === null || rootData === void 0 ? void 0 : rootData.campaignId
                      }));
                      return [4
                      /*yield*/
                      , toCreateOrder(__assign({}, firstSubjectSku_1), {
                        rootCampaignId: rootData === null || rootData === void 0 ? void 0 : rootData.campaignId,
                        signIndex: active_1,
                        mode: 'extends'
                      })];

                    case 1:
                      result = _a.sent();

                      if (!result) {
                        dom === null || dom === void 0 ? void 0 : dom.remove();
                      }

                      return [2
                      /*return*/
                      ];
                  }
                });
              });
            }
          });
          return [3
          /*break*/
          , 4];

        case 2:
          error_1 = _g.sent();
          console.log(error_1);
          return [3
          /*break*/
          , 4];

        case 3:
          Toast.hide();
          return [7
          /*endfinally*/
          ];

        case 4:
          return [2
          /*return*/
          ];
      }
    });
  });
};

var codeMap = [{
  code: 400,
  desc: '业务异常',
  flagCode: [{
    code: 403007,
    type: 'warn',
    title: '提示',
    content: '权益+其他组合售卖',
    btnText: '我知道了'
  }, {
    code: 403006,
    type: 'warn',
    title: '提示',
    content: '抱歉，此商品正在退款审核中',
    btnText: '我知道了'
  }, {
    code: 403005,
    type: 'warn',
    title: '提示',
    content: '抱歉，您暂不符合此商品购买条件',
    btnText: '我知道了'
  }, {
    code: 403004,
    type: 'warn',
    title: '提示',
    content: '您购买的商品已下架',
    btnText: '我知道了'
  }, {
    code: 403003,
    type: 'warn',
    title: '提示',
    content: '您购买的商品已下架',
    btnText: '我知道了'
  }, {
    code: 403002,
    type: 'warn',
    title: '提示',
    content: '您已达此商品购买上限',
    btnText: '我知道了'
  }, {
    code: 403001,
    type: 'warn',
    title: '提示',
    content: '您购买的商品已售罄',
    btnText: '我知道了'
  }, {
    code: 8,
    desc: '班级没有无老师'
  }, {
    code: 403,
    type: 'warn',
    title: '提示',
    content: '体验包兑换异常',
    btnText: '我知道了'
  }, {
    code: 406,
    type: 'warn',
    title: '提示',
    content: '您已经领过啦',
    btnText: '知道了'
  }, {
    code: 407,
    desc: '您近期已体验过相似内容'
  }, {
    code: 408,
    type: 'jump'
  }, {
    code: 410,
    type: 'warn',
    title: '提示',
    content: '渠道限制',
    btnText: '我知道了'
  }, {
    code: 411,
    type: 'warn',
    title: '提示',
    content: '抱歉，您不满足新用户领取规则，请退款后前往“爱阅读的叫叫”公众号领取',
    btnText: '我知道了'
  }, {
    code: 412,
    desc: '商城手机号限新'
  }, {
    code: 413,
    desc: 'UC登录注册失败'
  }, {
    code: 414,
    type: 'warn',
    title: '提示',
    content: '当前手机号已关联账号，请更换手机号再尝试',
    btnText: '我知道了'
  }, {
    code: 416,
    type: 'warn',
    title: '当前商品暂不支持购买',
    content: '换个商品看看吧',
    btnText: '我知道了'
  }, {
    code: 500010,
    desc: '未加师',
    type: 'custom',
    title: '内容已激活，请添加顾问体验',
    btnText: '添加顾问',
    trackType: '未加师'
  }, {
    code: 500011,
    desc: '已加师',
    type: 'custom',
    title: isJoJoApp ? '内容已激活，可立即体验' : '内容已激活，请前往APP体验',
    btnText: isJoJoApp ? '立即体验' : '前往APP',
    trackType: '已加师'
  }]
}, {
  code: 1,
  desc: '同科目在学'
}, {
  code: 6,
  desc: '存在相同课程售卖单'
}, {
  code: 7,
  desc: '子账号'
}, {
  code: 10,
  desc: '存在同科目未激活训练营'
}]; // HTML 转义：用户输入（姓名/详细地址）直插 innerHTML 前必须转义，防注入

export var escapeHtml = function escapeHtml(str) {
  return str.replace(/[&<>"']/g, function (ch) {
    return {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;'
    }[ch];
  });
};
/**
 * 将标题中的「激活」锚点替换为后端下发的动态关键词（激活/解锁）
 * @param title 现有静态标题（codeMap 配置，含「激活」锚点）；缺少锚点时保持原文并告警上报
 * @param keyword 后端按活动维度下发（frontErrorResp.mainMsg），空/非字符串兜底「激活」；
 *                非空字符串先经 HTML 转义再替换（防注入）
 */

export var replaceActivateKeyword = function replaceActivateKeyword(title, keyword) {
  if (!title) {
    return title;
  } // 锚点缺失说明 codeMap 文案被改动，动态文案将静默失效，告警并上报 Sentry 便于及时发现


  if (!title.includes('激活')) {
    console.warn("replaceActivateKeyword: \u6807\u9898\u7F3A\u5C11\u300C\u6FC0\u6D3B\u300D\u951A\u70B9\uFF0C\u52A8\u6001\u6587\u6848\u672A\u751F\u6548: ".concat(title));
    Sentry.captureException(new Error("replaceActivateKeyword: \u6807\u9898\u7F3A\u5C11\u300C\u6FC0\u6D3B\u300D\u951A\u70B9: ".concat(title)));
    return title;
  }

  var word = typeof keyword === 'string' && keyword ? escapeHtml(keyword) : '激活';
  return title.replace('激活', word);
};
/**
 * 微信小程序内嵌浏览器
 * @params {RootObject} data 报名｜下单｜支付查询｜接口返回
 * @params {ShowResType} this.data 活动页详情数据
 * @returns
 */

export var handleBuinessCode = function handleBuinessCode(data, rootData, cb) {
  return __awaiter(void 0, void 0, void 0, function () {
    var campaignId, jumpMiniAppsAbResult, linkId, campaignStr, toOpenMiniApp, flagCode, frontErrorResp, frontUserResp, // wechatMp,
    frontSoldNote, frontClassResp, frontOrderResp, frontEventTrackResp, codeObj, flagCode2_1, ffCodeObj, type_1, title_1, content_1, btnText_1, ffCode_1, dynamicTitle, _a, _b, id_1, sku, skuName, skuImage, createTime, orderDate, orderInfo, _c, title, content, btnText, className, code, type, subjectCodes, subjectString1_1, enPrm, _d, appId, wechatmpAppid, guideToWXQrCode, soldnoteId, _e, wxSchemaUrl, wechatAppId, params, wechatId, uri, orderId_1, course, legacyCourseName, legacyCourseId, soldNoteId, needShip, userCourseId_1, conflictSubjectCodes, courseId, courseName, _f, abtest, hasFrontOrderResp, subjectString, subjectContent;

    var _g, _h, _j, _k, _l, _m, _o, _p, _q;

    return __generator(this, function (_r) {
      switch (_r.label) {
        case 0:
          campaignId = rootData.campaignId, jumpMiniAppsAbResult = rootData.jumpMiniAppsAbResult, linkId = rootData.linkId;
          campaignStr = getCampaignStr(rootData);
          toOpenMiniApp = jumpMiniAppsAbResult === 'B2_230801' && !isInMiniProgram && !isJoJoApp && !isWx;
          flagCode = data.flagCode, frontErrorResp = data.frontErrorResp, frontUserResp = data.frontUserResp, frontSoldNote = data.frontSoldNote, frontClassResp = data.frontClassResp, frontOrderResp = data.frontOrderResp, frontEventTrackResp = data.frontEventTrackResp;
          codeObj = codeMap.find(function (item) {
            return item.code === flagCode;
          });
          if (!codeObj) return [3
          /*break*/
          , 10];
          if (!codeObj.flagCode) return [3
          /*break*/
          , 9];
          flagCode2_1 = (frontErrorResp || {}).flagCode;
          ffCodeObj = codeObj.flagCode.find(function (item) {
            return item.code === flagCode2_1;
          });
          if (!ffCodeObj) return [3
          /*break*/
          , 8];
          type_1 = ffCodeObj.type, title_1 = ffCodeObj.title, content_1 = ffCodeObj.content, btnText_1 = ffCodeObj.btnText, ffCode_1 = ffCodeObj.code;
          dynamicTitle = replaceActivateKeyword(title_1 || '', frontErrorResp === null || frontErrorResp === void 0 ? void 0 : frontErrorResp.mainMsg);
          _a = ffCode_1;

          switch (_a) {
            case 8:
              return [3
              /*break*/
              , 1];

            case 414:
              return [3
              /*break*/
              , 4];

            case 407:
              return [3
              /*break*/
              , 5];
          }

          return [3
          /*break*/
          , 6];

        case 1:
          if (!toOpenMiniApp) return [3
          /*break*/
          , 3];
          return [4
          /*yield*/
          , openPageByMiniprogram("".concat(LOCAL_BASE_URL, "/transferPage.html?noteacher=1").concat(campaignStr))];

        case 2:
          _r.sent();

          _r.label = 3;

        case 3:
          localUrlJump("/transferPage.html?noteacher=1".concat(campaignStr), true);
          return [2
          /*return*/
          ];

        case 4:
          promptFunc({
            title: '提示',
            content: (frontErrorResp === null || frontErrorResp === void 0 ? void 0 : frontErrorResp.mainMsg) || '',
            btnText: '我知道了'
          });
          return [2
          /*return*/
          ];

        case 5:
          beforeRenderPrompt({
            rootData: rootData,
            subjectString: '',
            failCallback: function failCallback() {
              var _a = getRender407Btn(),
                  popTitle = _a.title,
                  popBtnText = _a.btnText,
                  popBtnText2 = _a.btnText2,
                  popContent = _a.content,
                  onOk = _a.onOk;

              newPromptFunc({
                title: popTitle,
                content: popContent,
                btnText: popBtnText,
                btnText2: popBtnText2,
                hideCloseIcon: true,
                onOk: onOk
              });
            }
          });
          sensElementView({
            c_element_name: '下单异常弹窗曝光',
            url_id: linkId,
            activity_id: campaignId,
            material_ids: ["".concat(rootData === null || rootData === void 0 ? void 0 : rootData.campaignPageId)],
            activity_label: '投放',
            material_type: '异常原因：有在学/有待学/有7天内结营同科目',
            fail_reason: "".concat(frontErrorResp === null || frontErrorResp === void 0 ? void 0 : frontErrorResp.flagCode)
          });
          return [2
          /*return*/
          ];

        case 6:
          return [3
          /*break*/
          , 7];

        case 7:
          // 二级code 静态数据的code逻辑处理
          switch (type_1) {
            case 'warn':
              promptFunc({
                title: title_1 || undefined,
                content: content_1 || undefined,
                btnText: btnText_1 || undefined
              });
              return [2
              /*return*/
              ];

            case 'jump':
              urlJump("/error?code=".concat(ffCode_1));
              return [2
              /*return*/
              ];

            case 'custom':
              Toast.hide();

              if (ffCode_1 === 500011 && !isJoJoApp) {
                // 弹窗展示即预取下载页场景配置，网络延迟被用户阅读弹窗的时间吸收，onOk 时优先走缓存
                prefetchDownloadSceneType(campaignId);
              }

              _b = frontSoldNote || {}, id_1 = _b.id, sku = _b.sku, skuName = _b.skuName, skuImage = _b.skuImage, createTime = _b.createTime;
              orderDate = createTime == null ? null : dayjs(createTime);
              orderInfo = {
                courseImg: (_h = (_g = sku === null || sku === void 0 ? void 0 : sku.image) !== null && _g !== void 0 ? _g : skuImage) !== null && _h !== void 0 ? _h : '',
                courseName: (_k = (_j = sku === null || sku === void 0 ? void 0 : sku.name) !== null && _j !== void 0 ? _j : skuName) !== null && _k !== void 0 ? _k : '',
                orderTime: (orderDate === null || orderDate === void 0 ? void 0 : orderDate.isValid()) ? orderDate.format('YYYY-MM-DD HH:mm:ss') : ''
              };
              showSameActivityOrderModal(orderInfo, {
                title: dynamicTitle || '',
                btnText: btnText_1 || '',
                trackType: ffCodeObj.trackType,
                onOk: function onOk() {
                  var _a, _b;

                  switch (ffCode_1) {
                    case 500010:
                      urlJump("/exchange/add?t=1".concat(campaignStr, "&oid=").concat(id_1), true);
                      break;

                    case 500011:
                      {
                        // 已有内容形态：权益模式(EQUITY_SKU)仅有CMS权益无课程，jojoread APP 内跳伴读路由（复用既有常量），其余兜底学习页
                        // campaignMode 已在 RootDataType Pick 白名单显式声明（types/landing.d.ts 本次新增），无需类型断言
                        var soldNoteMode = (_b = (_a = frontSoldNote === null || frontSoldNote === void 0 ? void 0 : frontSoldNote.campaign) === null || _a === void 0 ? void 0 : _a.mode) !== null && _b !== void 0 ? _b : frontSoldNote === null || frontSoldNote === void 0 ? void 0 : frontSoldNote.campaignMode;
                        var contextMode = rootData === null || rootData === void 0 ? void 0 : rootData.campaignMode;
                        var isEquityMode = (soldNoteMode || contextMode) === 'EQUITY_SKU';

                        if (isJoJoApp) {
                          // 权益模式且在jojoread APP（tinman-router协议专属）：跳伴读路由；UP等其他APP内走学习页现状
                          var companionRoute = APP_ROUTE_INDEX_MAP[4];

                          if (isJoJoReadApp && isEquityMode && companionRoute) {
                            jumpAppRoute(companionRoute);
                          } else {
                            window.location.href = enums.schema.study;
                          }
                        } else {
                          // APP外：优先使用曝光预取缓存，命中时同步跳转（无网络等待，弹窗已 remove 也不出现真空窗口）；
                          // 未命中时 Toast.load 反馈后异步拉取，响应后 Toast.hide 并必完成跳转（与一键领课链路共用实现、兜底策略不同）
                          var cachedSceneType = getCachedDownloadSceneType(campaignId);

                          if (cachedSceneType) {
                            window.location.href = buildDownloadPageUrl(campaignId, linkId, cachedSceneType);
                          } else {
                            Toast.load('请稍后', 400000);
                            resolveDownloadPageUrl(campaignId, linkId).then(function (url) {
                              Toast.hide();
                              window.location.href = url;
                            });
                          }
                        }

                        break;
                      }

                    default:
                      break;
                  }
                }
              });
              return [2
              /*return*/
              ];

            default:
              // 默认情况
              handleFlag40(frontErrorResp);
              return [2
              /*return*/
              ];
          }

          return [3
          /*break*/
          , 9];

        case 8:
          handleFlag40(frontErrorResp);
          return [2
          /*return*/
          ];

        case 9:
          _c = codeObj, title = _c.title, content = _c.content, btnText = _c.btnText, className = _c.className, code = _c.code, type = _c.type;

          switch (code) {
            case 1:
              subjectCodes = (frontClassResp || {}).conflictSubjectCodes;
              subjectString1_1 = getSubjectString(subjectCodes);
              beforeRenderPrompt({
                rootData: rootData,
                subjectString: subjectString1_1,
                failCallback: function failCallback() {
                  handleFlagCode1(data, rootData, {
                    subjectString: subjectString1_1
                  });
                }
              });
              return [2
              /*return*/
              ];

            case 6:
              enPrm = query.enPrm;
              _d = data.wechatMp || {}, appId = _d.appId, wechatmpAppid = _d.wechatmpAppid, guideToWXQrCode = _d.guideToWXQrCode, soldnoteId = _d.soldnoteId, _e = _d.wxSchemaUrl, wxSchemaUrl = _e === void 0 ? '' : _e;
              wechatAppId = (_l = appId !== null && appId !== void 0 ? appId : wechatmpAppid) !== null && _l !== void 0 ? _l : '';
              params = qsParse(decodeURIComponent(enPrm));
              wechatId = null;

              if (/^http/.test(wxSchemaUrl)) {
                wechatId = /wxaurl.cn\/(\w+)/.exec(wxSchemaUrl);
              } else {
                wechatId = /t=(\w+)$/.exec(wxSchemaUrl);
              }

              uri = "/transferPage.html?appId=".concat(wechatAppId, "&linkId=").concat(linkId, "&channel=").concat(query.channel || params.channel || '', "&channelNo=").concat(query.channelNo || params.channelNo || '', "&oid=").concat(soldnoteId || '', "&guideToWXQrCode=").concat(guideToWXQrCode || '', "&enPrm=").concat(enPrm || '', "&maId=").concat(wechatId ? wechatId[1] : '').concat(campaignStr);
              localUrlJump(uri, true);
              return [2
              /*return*/
              ];

            case 7:
              promptFunc({
                title: '温馨提示',
                phone: (frontUserResp === null || frontUserResp === void 0 ? void 0 : frontUserResp.nickname) || 'jojo用户',
                btnText: '暂不领取',
                btnText2: '确认并解绑',
                hideCloseIcon: true,
                code: 7,
                onOk: function onOk() {
                  return __awaiter(void 0, void 0, void 0, function () {
                    var error_2;
                    return __generator(this, function (_a) {
                      switch (_a.label) {
                        case 0:
                          _a.trys.push([0, 2,, 3]);

                          return [4
                          /*yield*/
                          , unbindAccount().then(function (res) {
                            var _a;

                            if ((res === null || res === void 0 ? void 0 : res.resultCode) === 200 && ((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.userId)) {
                              if (cb) {
                                cb();
                              }
                            } else {
                              Toast.fail('出错了，请稍后再试');
                            }
                          })];

                        case 1:
                          _a.sent();

                          return [3
                          /*break*/
                          , 3];

                        case 2:
                          error_2 = _a.sent();
                          console.log(error_2);
                          return [3
                          /*break*/
                          , 3];

                        case 3:
                          return [2
                          /*return*/
                          ];
                      }
                    });
                  });
                }
              });
              return [2
              /*return*/
              ];

            case 10:
              if (!frontOrderResp) {
                Toast.fail(_trans('courseSelection.toast.dataErr'));
                return [2
                /*return*/
                ];
              }

              orderId_1 = frontOrderResp.orderId, course = frontOrderResp.course, legacyCourseName = frontOrderResp.courseName, legacyCourseId = frontOrderResp.courseId, soldNoteId = frontOrderResp.soldNoteId, needShip = frontOrderResp.needShip, userCourseId_1 = frontOrderResp.userCourseId, conflictSubjectCodes = frontOrderResp.conflictSubjectCodes;
              courseId = (_o = (_m = course === null || course === void 0 ? void 0 : course.id) !== null && _m !== void 0 ? _m : legacyCourseId) !== null && _o !== void 0 ? _o : '';
              courseName = (_q = (_p = course === null || course === void 0 ? void 0 : course.name) !== null && _p !== void 0 ? _p : legacyCourseName) !== null && _q !== void 0 ? _q : '';
              _f = (frontEventTrackResp || {}).abtest, abtest = _f === void 0 ? '' : _f;
              hasFrontOrderResp = frontOrderResp && frontOrderResp.needAnswer;
              subjectString = getSubjectString(conflictSubjectCodes);
              subjectContent = getRender1Btn({
                subjectString: subjectString,
                isActive: true
              }).content; // 新增userCourseId判断流程

              if (userCourseId_1) {
                promptFunc({
                  title: _trans('courseSelection.prompt.titleRecur'),
                  content: subjectContent || courseName,
                  btnText: _trans('courseSelection.prompt.btnActivate'),
                  btnText2: '知道了',
                  hasSecondeBtn: true,
                  hideCloseIcon: true,
                  onOk: function onOk() {
                    sensClickInitiative({
                      $element_name: '投放落地页_手机未激活弹窗_去激活',
                      material_position: '投放落地页_手机未激活弹窗',
                      activity_label: '投放'
                    });
                    localUrlJump("/transferPage.html?userCourseId=".concat(userCourseId_1).concat(campaignStr), true);
                  }
                });
                return [2
                /*return*/
                ];
              }

              if (orderId_1 && orderId_1 !== '0') {
                sensElementView({
                  c_element_name: '投放落地页_手机未激活弹窗',
                  activity_label: '投放'
                });
                promptFunc({
                  title: _trans('courseSelection.prompt.titleRecur'),
                  content: subjectContent || courseName,
                  btnText: _trans('courseSelection.prompt.btnActivate'),
                  btnText2: '知道了',
                  hasSecondeBtn: true,
                  hideCloseIcon: true,
                  onOk: function onOk() {
                    sensClickInitiative({
                      $element_name: '投放落地页_手机未激活弹窗_去激活',
                      material_position: '投放落地页_手机未激活弹窗',
                      activity_label: '投放'
                    });
                    localUrlJump("/transferPage.html?orderId=".concat(orderId_1).concat(campaignStr), true);
                  }
                });
                return [2
                /*return*/
                ];
              }

              if (!soldNoteId) {
                Toast.fail(_trans('courseSelection.toast.dataErr'));
                return [2
                /*return*/
                ];
              }

              toOrderModal({
                viewReport: {
                  c_element_name: '投放落地页_手机未激活弹窗',
                  activity_label: '投放'
                },
                clickReport: {
                  $element_name: '投放落地页_手机未激活弹窗_去激活',
                  material_position: '投放落地页_手机未激活弹窗',
                  activity_label: '投放'
                },
                needShip: needShip,
                subjectContent: subjectContent,
                courseId: courseId,
                soldNoteId: soldNoteId,
                abtest: abtest,
                hasFrontOrderResp: hasFrontOrderResp,
                frontOrderResp: frontOrderResp
              }, rootData);
              return [2
              /*return*/
              ];

            default:
              break;
          }

          switch (type) {
            case 'warn':
              promptFunc({
                title: title || undefined,
                content: content || undefined,
                btnText: btnText || undefined,
                className: className || undefined
              });
              return [2
              /*return*/
              ];

            case 'jump':
              urlJump("/error?code=".concat(code));
              return [2
              /*return*/
              ];

            default:
              handleFlag40(frontErrorResp);
              return [2
              /*return*/
              ];
          }

          _r.label = 10;

        case 10:
          handleFlag40(frontErrorResp);
          return [2
          /*return*/
          ];
      }
    });
  });
};